// src/components/MetricsBar.jsx
import { useDataStore } from '../stores/dataStore'

export default function MetricsBar() {
  const metrics = useDataStore(s => s.metrics)

  const memory = metrics?.memory || {}
  const cpu = metrics?.cpu || {}

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 24,
      padding: '8px 20px',
      borderBottom: '1px solid var(--border-subtle)',
      background: 'var(--bg-surface)',
      flexShrink: 0,
    }}>
      <MetricItem
        label="CPU"
        value={`${cpu.percentUsed}%`}
        detail={`${cpu.coreCount}-core · load ${cpu.loadAvg1m}`}
        percent={cpu.percentUsed}
        color={cpu.percentUsed > 80 ? 'var(--accent-red)' : cpu.percentUsed > 60 ? 'var(--accent-amber)' : 'var(--accent-cyan)'}
      />

      {/* Divider */}
      <div style={{ width: 1, height: 28, background: 'var(--border-subtle)' }} />

      {/* Memory */}
      <MetricItem
        label="Memory"
        value={`${memory.usedGB} GB`}
        detail={`of ${memory.totalGB} GB · ${memory.percentUsed}% used`}
        percent={memory.percentUsed}
        color={memory.percentUsed > 85 ? 'var(--accent-red)' : memory.percentUsed > 70 ? 'var(--accent-amber)' : 'var(--accent-blue)'}
      />

      {/* Model name - right aligned */}
      <div style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--text-tertiary)', fontFamily: 'var(--font-mono)' }}>
        {cpu.model}
      </div>
    </div>
  )
}

function MetricItem({ label, value, detail, percent, color }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      {/* Mini ring */}
      <svg width="32" height="32" style={{ flexShrink: 0 }}>
        <circle cx="16" cy="16" r="13" fill="none" stroke="var(--border-default)" strokeWidth="2.5" />
        <circle
          cx="16" cy="16" r="13"
          fill="none"
          stroke={color}
          strokeWidth="2.5"
          strokeDasharray={`${(percent / 100) * 81.7} 81.7`}
          strokeLinecap="round"
          transform="rotate(-90 16 16)"
          style={{ transition: 'stroke-dasharray 0.5s ease' }}
        />
      </svg>

      <div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
          <span style={{ fontSize: 10, color: 'var(--text-tertiary)', fontFamily: 'var(--font-mono)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
            {label}
          </span>
          <span style={{ fontSize: 14, fontWeight: 600, color, fontFamily: 'var(--font-mono)' }}>
            {value}
          </span>
        </div>
        <div style={{ fontSize: 11, color: 'var(--text-tertiary)' }}>
          {detail}
        </div>
      </div>
    </div>
  )
}
